import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';
import { COOKIE_KEYS } from '../config/cookieConstants';
import { AppRoutes } from './AppRoutes';

const SelectCompanyRoute: React.FC = () => {
  const token = Cookies.get(COOKIE_KEYS.TOKEN);
  const uuid = Cookies.get(COOKIE_KEYS.UUID);

  if (!token || !uuid) {
    return <Navigate to={AppRoutes.LOGIN} replace />;
  }

  return <Outlet />;
};

export default SelectCompanyRoute;
